import { v1 } from 'uuid';
import { isString } from './isString';

const uuidRegExp = /\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/;

export const uuid = () => v1();
export const isUuid = (value) => isString(value) && value.match(uuidRegExp);
